/**
 * Capacitor App Listeners
 *
 * Handles deep linking for Supabase OAuth callbacks on iOS/Android
 */

import { App } from '@capacitor/app';
import { supabase } from '~/supabaseClient';

/**
 * Initialize Capacitor app listeners
 * Call this once when the app starts
 */
export function initializeCapacitorListeners() {
  // Handle deep link URL opens (for OAuth callbacks)
  App.addListener('appUrlOpen', async (event) => {
    console.log('[Capacitor] App URL opened:', event.url);

    try {
      const url = new URL(event.url);

      // Handle Supabase OAuth callback
      // URL formats supported:
      // - com.pressingspace.yomidi:///oauth/callback → pathname="/oauth/callback"
      // - com.pressingspace.yomidi://oauth/callback → host="oauth", pathname="/callback"
      const isOAuthCallback =
        url.pathname === '/oauth/callback' ||
        (url.host === 'oauth' && url.pathname === '/callback');

      if (isOAuthCallback) {
        console.log('[Capacitor] Processing OAuth callback');

        // Extract the hash fragment that contains the access token
        const hashParams = new URLSearchParams(url.hash.substring(1));

        // Get session from URL params (Supabase OAuth response)
        const { error } = await supabase.auth.setSession({
          access_token: hashParams.get('access_token') || '',
          refresh_token: hashParams.get('refresh_token') || '',
        });

        if (error) {
          console.error('[Capacitor] OAuth callback error:', error);
        } else {
          console.log('[Capacitor] OAuth callback successful');
        }
      }
    } catch (error) {
      console.error('[Capacitor] Error processing app URL:', error);
    }
  });

  // Handle app state changes
  App.addListener('appStateChange', (state) => {
    console.log('[Capacitor] App state changed:', state.isActive ? 'active' : 'background');
  });

  console.log('[Capacitor] Listeners initialized');
}

/**
 * Remove all app listeners
 * Call this when cleaning up
 */
export async function removeCapacitorListeners() {
  await App.removeAllListeners();
  console.log('[Capacitor] Listeners removed');
}
